module.exports = __webpack_public_path__ + "static/media/company_logo4.bee2ccbc.png";